import setLanguage from "@/shared/utils/translation";
import { ChevronDown, ChevronUp } from "@reverb-ui/icons-react";
import { Button, Center, Flex, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Radio, RadioGroup, Stack, Text, useDisclosure, useColorModeValue, Spinner, } from "@reverb-ui/react";
import React, { useEffect, useState } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import { chooseLanguage_en } from "../../../../main/i18n/en";
import { chooseLanguage_pt_br } from "../../../../main/i18n/pt-br";
import { BrazilIcon, USAIcon } from "../icons";
var languages = [
    {
        value: "pt-br",
        component: function (fontColor, key) { return (React.createElement(MenuItem, { cursor: "pointer", key: key },
            React.createElement(Radio, { value: "pt-br", w: "100%" },
                React.createElement(Flex, { align: "center", cursor: "pointer" },
                    React.createElement(BrazilIcon, null),
                    React.createElement(Text, { ml: "2", mr: "2", fontSize: "md", color: fontColor, fontWeight: "400" }, "PT-BR"))))); },
    },
    {
        value: "en-us",
        component: function (fontColor, key) { return (React.createElement(MenuItem, { cursor: "pointer", key: key },
            React.createElement(Radio, { value: "en-us", w: "100%" },
                React.createElement(Flex, { align: "center", cursor: "pointer" },
                    React.createElement(USAIcon, null),
                    React.createElement(Text, { ml: "2", mr: "2", fontSize: "md", color: fontColor, fontWeight: "400" }, "EN-US"))))); },
    },
];
export var ChooseLanguage = function () {
    var _a, _b;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useTranslation("choose-language"), t = _d[0], i18n = _d[1];
    var _e = useState(i18n.language.toLocaleLowerCase()), currentLanguage = _e[0], setCurrentLanguage = _e[1];
    var fontColor = useColorModeValue("gray.800", "white");
    // list of languages and icons
    var listLanguages = {
        "pt-br": {
            icon: React.createElement(BrazilIcon, null),
            language: "Portuguese (BR)",
        },
        pt: {
            icon: React.createElement(BrazilIcon, null),
            language: "Portuguese (BR)",
        },
        en: {
            icon: React.createElement(USAIcon, null),
            language: "English (US)",
        },
        "en-us": {
            icon: React.createElement(USAIcon, null),
            language: "English (US)",
        },
    };
    var _f = useDisclosure(), onClose = _f.onClose, onOpen = _f.onOpen, isOpen = _f.isOpen;
    useEffect(function () {
        setCurrentLanguage(i18n.language.toLocaleLowerCase());
    }, [i18n.language]);
    useEffect(function () {
        i18n.addResourceBundle("en", "choose-language", chooseLanguage_en);
        i18n.addResourceBundle("pt", "choose-language", chooseLanguage_pt_br);
        setLoading(false);
    });
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(Center, { "data-testid": "choose-language-component" }, loading ? (React.createElement(Center, { w: "100%", h: "100%" },
            React.createElement(Spinner, null))) : (React.createElement(Menu, { placement: "bottom-end" },
            React.createElement(MenuButton, { as: Button, colorScheme: "white", leftIcon: ((_a = listLanguages[currentLanguage]) === null || _a === void 0 ? void 0 : _a.icon) || listLanguages.en.icon, rightIcon: isOpen ? (React.createElement(ChevronUp, { color: fontColor })) : (React.createElement(ChevronDown, { color: fontColor })), _focus: { outline: "none" } },
                React.createElement(Text, { fontSize: "sm", color: fontColor, fontWeight: "medium" }, ((_b = listLanguages[currentLanguage]) === null || _b === void 0 ? void 0 : _b.language) ||
                    listLanguages.en.language)),
            React.createElement(MenuList, { zIndex: "dropdown", pr: "1", onFocus: onOpen, onBlur: onClose },
                React.createElement(MenuGroup, { title: t("choose-language.choose-a-language") },
                    React.createElement(RadioGroup, { onChange: function (language) { return setLanguage(language); }, value: currentLanguage },
                        React.createElement(Stack, null, languages
                            .sort(function (a, b) { return (a.value === currentLanguage ? -1 : 1); })
                            .map(function (language) {
                            return language.component(fontColor, language.value);
                        }))))))))));
};
